import Helper from './Helper';

export default class Merger {
	constructor(source, target) {
		this.$source = source;
		this.$target = target;
		this.$warnings = [];
	}

	addWarning(message) {
		const warning = {message};
		this.$warnings.push(warning);
	}

	stepMatch(source, target) {
		return source.step_id === target.step_id;
	}

	propertyMatch(source, target) {
		const field = source.stepable_id ? 'stepable_id' : 'name';
		const reference = source[field] === target[field];
		const type = source.property_type === target.property_type;
		return reference && type;
	}

	validInput(source, target) {
		let valid = ['infomore'].includes(source.type);
		if (!valid) {
			const selected = source.selected;
			const id = selected.id || selected.option_value_id || selected.value;
			if (id && Array.isArray(target.values))
				for (let value of target.values) {
					valid = id === value.id;
					if (valid) break;
				}
		}

		return valid;
	}

	validInfo(source, target) {
		return true;
	}

	validUpgrade(source, target) {
		let valid = false;
		if (Array.isArray(target.groups))
			for (let group of target.groups)
				if (source.selected.upgrade === group.upgrade_id)
					if (Array.isArray(group.values))
						for (let value of group.values) {
							valid = source.selected.value === value.id;
							if (valid) break;
						}

		return true;
	}

	validUpsell(source, target) {
		let valid = !source.selected.data;
		if (!valid) {
			valid = true;
			for (let source_item of source.selected.data) {
				let found = false;
				if (Array.isArray(target.groups))
					for (let target_group of target.groups)
						if (Helper.is(target_group.values))
							if (source_item.id === target_group.values.id)
								{ found = true; break; }

				if (!found)
					{ valid = false; break; }
			}
		}

		return valid;
	}

	validBundle(source, target) {
		let valid = !source.selected.value;
		if (!valid) valid = source.selected.value === target.id;
		return valid;
	}

	propertyValid(source, target) {
		let valid = false;
		const type = source.property_type;
		switch (type) {
			case 'options': valid = this.validInput(source, target); break;
			case 'infos': valid = this.validInfo(source, target); break;
			case 'upgrades': valid = this.validUpgrade(source, target); break;
			case 'upsells': valid = this.validUpsell(source, target); break;
			case 'bundles': valid = this.validBundle(source, target); break;
		}

		return valid;
	}

	merged() {
		for (let source_step of this.$source.steps) {
			let step_found = false;
			for (let target_step of this.$target.steps)
				if (this.stepMatch(source_step, target_step)) {
					step_found = true;
					for (let source_property of source_step.properties)
						if (Helper.is(source_property.selected)) {
							let property_found = false;
							for (let target_property of target_step.properties)
								if (this.propertyMatch(source_property, target_property)) {
									property_found = true;

									const valid = this.propertyValid(source_property, target_property);
									if (valid) target_property.selected = source_property.selected;
									else this.addWarning(`De keuze <b>${source_property.selected.label}</b> bij <b>${source_property.name}</b> is niet geldig in de nieuwe configuratie.`);
									break;
								}

							if (!property_found)
								this.addWarning(`De eigenschap <b>${source_property.name}</b> is niet in de nieuwe configuratie beschikbaar.`);
						}

					break;
				}

			if (!step_found)
				this.addWarning(`De stap <b>${source_step.name}</b> is niet in de nieuwe configuratie beschikbaar.`);
		}

		return this.$target;
	}

	warnings() {
		return this.$warnings;
	}
}